module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAAXNSR0IArs4c6QAAADxQTFRFAAAAp6O0qaW0pqa2p6S3qaW0pqa1p6W1p6a1p6W0p6W1p6S1p6a1p6W1p6a1p6W1p6W1p6W1p6W1p6W1ygSMIgAAABN0Uk5TAD1BQkNERcDCw8TF0OPk5urr93ZBQl4AAABGSURBVCjPY2CAA1Z+fiYGbIBbWJgdqwSPsDDP0JVg4+SBAiFhYSEYm4OZQVAYK+BnEMAlwYLLqOESVgjAhSsxMPPxMiJ4AC9vCl1BYvp7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add@2x.png
// module id = wUQQ
// module chunks = 44